<template>
  <el-dialog
    v-model="isOpen"
    :title="alert.title"
    width="750px"
    top="6vh"
    class="el-dialog--spaceless-body"
    append-to-body
  >
    <template #header>
      <span>
        <icon-warning class="text-text-light" /> {{ alert.title }}
      </span>
    </template>
    <div>
      <p
        class="mb-6 mx-5"
        v-html="(alert.description || '').replace(/\n/g, '<br>')"
      />
      <div
        v-if="alert.link"
        class="video-wrapper"
      >
        <iframe
          width="560"
          height="315"
          :src="`https://app.tichalinka.cz/youtube.html?v=${getYouTubeID(alert.link)}&autoplay=1`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
        <div class="video-placeholder flex items-center justify-center">
          <icon-loading />
        </div>
      </div>
    </div>

    <template #footer>
      <div

        class="text-center w-full"
      >
        <el-button
          size="small"
          @click="isOpen = false"
        >
          Zavřít
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      alert: {},
    };
  },

  async mounted() {
    try {
      this.isLoading = true;
      const response = await useApi.get('/messages');
      const messageId = useAuthStore().user?.lang === 'ua' ? 2 : 1;
      const message = response?.results?.find((message) => message.id === messageId);

      if (message) {
        this.alert = message;
        this.isOpen = true;
      }

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },
};
</script>
